import { makeStyles } from '@mui/styles';
import { useTheme } from '@mui/material';

const styles = makeStyles(() => ({
	box: {
		backgroundColor: 'rgb(255, 255, 255)',
		boxShadow:
			'rgba(0, 0, 0, 0.06) 0px 5px 5px -3px, rgba(0, 0, 0, 0.043) 0px 8px 10px 1px, rgba(0, 0, 0, 0.035) 0px 3px 14px 2px',
		position: 'sticky',
		top: 0,
		zIndex: useTheme().zIndex.appBar,
	},
	stack: {
		minHeight: 64,
		paddingLeft: useTheme().spacing(2),
		paddingRight: useTheme().spacing(2),
		display: 'flex',
		alignItems: 'center',
		flexDirection: 'row',
		justifyContent: 'space-between',
	},
	svgIcon: {
		color: 'black',
	},
	user: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'space-between',
	},
	avatar: {
		cursor: 'pointer',
		height: 40,
		width: 40,
		marginLeft: useTheme().spacing(2),
	},
}));

export default styles;
